import { ReactNode } from 'react';
import { Wrapper } from './Caption.styles';

interface CaptionProps {
  children?: ReactNode;
  'data-testid'?: string;
}

export const Caption = ({
  children,
  ['data-testid']: dataTestId,
}: CaptionProps) => <Wrapper data-testid={dataTestId}>{children}</Wrapper>;
